/* Version: 3.5.155 */
'use client';
var PROGRESS_BAR_VARIANT = {
  PERCENTAGE: 'percentage',
  STEPS: 'steps'
};

export { PROGRESS_BAR_VARIANT };
